import type { StatusChipProps } from '@/components/chip/ChipRole';
import ChipRole from '@/components/chip/ChipRole';
import { RoleEnum } from '@/types/enums/role.enum';

export const getRoleData = (props: StatusChipProps) => {
    return ChipRole(props);
};

export const getRoleOptionsFilter = (isFilter?: boolean, theme?: any) => {
    const enumValues = RoleEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getRoleData({
            status: enumValues[key],
            showChip: false,
            theme,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: data.label,
            color: data.colorHex,
        });
    });

    return options;
};
